/**
 * Appointment Route
 * Appointment details and confirmation
 */
import { createFileRoute } from "@tanstack/react-router";
import { AppointmentPage } from "../pages/AppointmentPage";

export const Route = createFileRoute("/appointment/$appointmentId")({
  component: AppointmentPage,
});
